import { post } from '../axios'

// 获取日志信息
export function bizLog_get_biz_logs_post(map, option) {
  return post(
    `${process.env.VUE_APP_BIZLOG}/bizLog/get-biz-logs`,
    map,
    option
  ).then(response => response)
}

// 获取日志信息分页
export function bizLog_page_biz_logs_post(map, option) {
  return post(
    `${process.env.VUE_APP_BIZLOG}/bizLog/page-biz-logs`,
    map,
    option
  ).then(response => response)
}

// 获取历史日志信息
export function bizLog_get_history_biz_logs_post(map, option) {
  return post(
    `${process.env.VUE_APP_BIZLOG}/bizLog/get-history-biz-logs`,
    map,
    option
  ).then(response => response)
}
